import React, { useState } from 'react';

const SubjectTabs = ({ tabs, active, onChange }) => {
  const [hoveredTab, setHoveredTab] = useState(null);

  return (
      <div className="container-fluid tabs my-5 padding-bottom-10">
        <div className="row justify-content-center">
          <div className="col-md-10 col-xl-6">
            <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
              {tabs.map((tab) => (
                <div
                  key={tab.key}
                  className="col-auto margin-bottom-10"
                  onClick={() => onChange && onChange(tab.key)}
                  onMouseEnter={() => setHoveredTab(tab.key)}
                  onMouseLeave={() => setHoveredTab(null)}
                  style={{
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    transform: hoveredTab === tab.key ? 'scale(1.05)' : 'scale(1)',
                  }}
                >
                  <img
                    src={
                      active === tab.key || hoveredTab === tab.key
                        ? tab.hoverImage
                        : tab.image
                    }
                    alt={tab.label}
                    style={{
                      maxWidth: '200px',
                      height: 'auto',
                      display: 'block',
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  );
};

export default SubjectTabs;
